<script>
import resources from './resources'

export default {
  name: 'professional-specialities-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Minhas Especialidades", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          .nav-tab-wrapper
            tab(v-if="specialities.length < 5")
          .col-xs-12.white-bg.wrapper
            card-add(v-if="specialities.length < 5", label='Nova<br>Especialidade', route='professional.record.specialities.create', icon='')
            .list-item.white-bg.list-item(v-for="speciality in specialities")
              .row.border-bottom
                h4.col-xs-7(v-tooltip="speciality.label") {{ speciality.label_small }}
                  br
                .col-xs-5
                  .exclude-list(@click.prevent="doDelete(speciality)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: speciality.id}}")
                    .edit-list
                      span.icon 
              .list-info
                strong RQE
                |  {{ speciality.rqe }}
</template>



// WEBPACK FOOTER //
// src/app/professional/record/specialities/index/index.vue